import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Companion, Deleteparam } from '../companion.model';

export enum CompanionActionTypes {
  GetCompanions = '[Companion] Get Companions',
  GetCompanionsFail = '[Companion] Get Companions Fail',
  UpsertCompanions = '[Companion] Upsert Companions',
  DeleteCompanion = '[Companion] Delete Companion',
  DeleteCompanionSuccess = '[Companion] Delete Companion Success',
  DeleteCompanionFail = '[Companion] Delete Companion Fail',
  NoCompanions = '[Companion] No Companions',
  GetCompanionsOverView = '[Companion] Get Companions OverView',
  GetCompanionsOverViewSuccess = '[Companion] Get Companions OverView Success',
  GetCompanionsOverViewFail = '[Companion] Get Companions OverView Fail',
  SendKeyToApp = '[Companion] Send Key To App',
  SendKeyToAppFail = '[Companion] Send Key To App Fail',
  GetCompanionProtectionProcessDevice = '[Companion] Get Companion Protection Process Device',
  GetCompanionProtectionProcessDeviceSuccess = '[Companion] Get Companion Protection Process Device Success',
  GetCompanionProtectionProcessDeviceFail = '[Companion] Get Companion Protection Process Device Fail',
  ConfirmCompanionProtectionProcess = '[Companion] Confirm Companion Protection Process',
  ConfirmCompanionProtectionProcessFail = '[Companion] Confirm Companion Protection Process Fail',
  SendKeyOfCompanionProtectionProcess = '[Companion] Send Key Of Companion Protection Process',
  SendKeyOfCompanionProtectionProcessFail = '[Companion] Send Key Of Companion Protection Process Fail',
  ResendDataOfCompanionProtectionProcess = '[Companion] Resend Data Of Companion Protection Process',
  ResendDataOfCompanionProtectionProcessSuccess = '[Companion] Resend Data Of Companion Protection Process Success',
  ResendDataOfCompanionProtectionProcessFail = '[Companion] Resend Data Of Companion Protection Process Fail',
  StopCompanionProtectionProcess = '[Companion] Stop Companion Protection Process',
  StopCompanionProtectionProcessFail = '[Companion] Stop Companion Protection Process Fail',
  UpdateCompanionReceipt = '[Companion] Update Companion Receipt',
  UpdateCompanionReceiptFail = '[Companion] Update Companion Receipt Fail',
  UpdateCompanionOfflineNotification = '[Companion] Update Companion Offline Notification',
  UpdateCompanionOfflineNotificationFail = '[Companion] Update Companion Offline Notification Fail',
}


export class GetCompanions implements Action {
  readonly type = CompanionActionTypes.GetCompanions;

  constructor(public payload: any = null) {}
}

export class GetCompanionsFail implements Action {
  readonly type = CompanionActionTypes.GetCompanionsFail;
}

export class UpsertCompanions implements Action {
  readonly type = CompanionActionTypes.UpsertCompanions;

  constructor(public payload: any = null) {}
}

export class DeleteCompanionSuccess implements Action {
  readonly type = CompanionActionTypes.DeleteCompanionSuccess;

  constructor(public payload: any = null) {
  }
}

export class DeleteCompanionFail implements Action {
  readonly type = CompanionActionTypes.DeleteCompanionFail;

  constructor(public payload: any = null) {
  }
}

export class DeleteCompanion implements Action {
  readonly type = CompanionActionTypes.DeleteCompanion;

  constructor(public payload: Deleteparam) {}
}

export class NoCompanions implements Action {
  readonly type = CompanionActionTypes.NoCompanions;
}

export class GetCompanionsOverView implements Action {
  readonly type = CompanionActionTypes.GetCompanionsOverView;

  constructor(public payload: any = null) {}
}
export class GetCompanionsOverViewSuccess implements Action {
  readonly type = CompanionActionTypes.GetCompanionsOverViewSuccess;

  constructor(public payload: any = null) {
  }
}
export class GetCompanionsOverViewFail implements Action {
  readonly type = CompanionActionTypes.GetCompanionsOverViewFail;

  constructor(public payload: any = null) {
  }
}
export class SendKeyToApp implements Action {
  readonly type = CompanionActionTypes.SendKeyToApp;

  constructor(public payload: any = null) {}
}
export class SendKeyToAppFail implements Action {
  readonly type = CompanionActionTypes.SendKeyToAppFail;

  constructor(public payload: any = null) {
  }
}
export class GetCompanionProtectionProcessDevice implements Action {
  readonly type = CompanionActionTypes.GetCompanionProtectionProcessDevice;

  constructor(public payload: any = null) {}
}
export class GetCompanionProtectionProcessDeviceSuccess implements Action {
  readonly type = CompanionActionTypes.GetCompanionProtectionProcessDeviceSuccess;

  constructor(public payload: any = null) {
  }
}
export class GetCompanionProtectionProcessDeviceFail implements Action {
  readonly type = CompanionActionTypes.GetCompanionProtectionProcessDeviceFail;

  constructor(public payload: any = null) {
  }
}
export class ConfirmCompanionProtectionProcess implements Action {
  readonly type = CompanionActionTypes.ConfirmCompanionProtectionProcess;

  constructor(public payload: any = null) {}
}
export class ConfirmCompanionProtectionProcessFail implements Action {
  readonly type = CompanionActionTypes.ConfirmCompanionProtectionProcess;

  constructor(public payload: any = null) {
  }
}
export class SendKeyOfCompanionProtectionProcess implements Action {
  readonly type = CompanionActionTypes.SendKeyOfCompanionProtectionProcess;

  constructor(public payload: any = null) {}
}
export class SendKeyOfCompanionProtectionProcessFail implements Action {
  readonly type = CompanionActionTypes.SendKeyOfCompanionProtectionProcessFail;

  constructor(public payload: any = null) {
  }
}
export class ResendDataOfCompanionProtectionProcess implements Action {
  readonly type = CompanionActionTypes.ResendDataOfCompanionProtectionProcess;

  constructor(public payload: any = null) {}
}
export class ResendDataOfCompanionProtectionProcessSuccess implements Action {
  readonly type = CompanionActionTypes.ResendDataOfCompanionProtectionProcessSuccess;

  constructor(public payload: any = null) {}
}
export class ResendDataOfCompanionProtectionProcessFail implements Action {
  readonly type = CompanionActionTypes.ResendDataOfCompanionProtectionProcessFail;

  constructor(public payload: any = null) {
  }
}
export class StopCompanionProtectionProcess implements Action {
  readonly type = CompanionActionTypes.StopCompanionProtectionProcess;

  constructor(public payload: any = null) {}
}
export class StopCompanionProtectionProcessFail implements Action {
  readonly type = CompanionActionTypes.StopCompanionProtectionProcessFail;

  constructor(public payload: any = null) {
  }
}
export class UpdateCompanionReceipt implements Action {
  readonly type = CompanionActionTypes.UpdateCompanionReceipt;

  constructor(public payload: any = null) {}
}
export class UpdateCompanionReceiptFail implements Action {
  readonly type = CompanionActionTypes.UpdateCompanionReceiptFail;

  constructor(public payload: any = null) {
  }
}
export class UpdateCompanionOfflineNotification implements Action {
  readonly type = CompanionActionTypes.UpdateCompanionOfflineNotification;

  constructor(public payload: any = null) {}
}
export class UpdateCompanionOfflineNotificationFail implements Action {
  readonly type = CompanionActionTypes.UpdateCompanionOfflineNotificationFail;

  constructor(public payload: any = null) {
  }
}

export type CompanionActions =
GetCompanions
 | GetCompanionsFail
 | UpsertCompanions
 | DeleteCompanion
 | DeleteCompanionSuccess
 | DeleteCompanionFail
 | NoCompanions
 | GetCompanionsOverView
 | GetCompanionsOverViewSuccess
 | GetCompanionsOverViewFail
 | SendKeyToApp
 | SendKeyToAppFail
 | GetCompanionProtectionProcessDevice
 | GetCompanionProtectionProcessDeviceSuccess
 | GetCompanionProtectionProcessDeviceFail
 | ConfirmCompanionProtectionProcess
 | ConfirmCompanionProtectionProcessFail
 | SendKeyOfCompanionProtectionProcess
 | SendKeyOfCompanionProtectionProcessFail
 | ResendDataOfCompanionProtectionProcess
 | ResendDataOfCompanionProtectionProcessSuccess
 | ResendDataOfCompanionProtectionProcessFail
 | StopCompanionProtectionProcess
 | StopCompanionProtectionProcessFail
 | UpdateCompanionReceipt
 | UpdateCompanionReceiptFail
 | UpdateCompanionOfflineNotification
 | UpdateCompanionOfflineNotificationFail;
